import * as _ from 'underscore';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { IDialogButton } from '../ga-message.service';
import { util } from '../../util';

@Component({
  selector: 'default-dialog',
  template:
    `<div class="message-dialog" [ngClass]="dialogClass">
        <div class="modal-header" *ngIf="!hideHeader">
          <h4 class="modal-title" translate>{{ title }}</h4>
          <button *ngIf="closeButton" type="button" class="btn-close" (click)="close('x')">
            <span class="visually-hidden" translate>GA.BUTTONS.CLOSE</span>
          </button>
        </div>

      <div class="modal-body">
        <div *ngIf="loading">
          <activity-indicator></activity-indicator>
        </div>
        <div *ngIf="!loading" class="modal-content-container">
          <ng-content></ng-content>
          <div *ngIf="message" [innerHTML]="message" translate></div>
        </div>
      </div>

      <div class="modal-footer" *ngIf="!hideFooter">
        <button *ngFor="let button of buttons" [busyButton]="button.busy" [disabled]="button.disabled || (!isCancelOrCloseButton(button) && loading)" class="btn" [ngClass]="button.className" (click)="btnCallBack($event, button)" translate><i class="fa margin-right-xs" [ngClass]="button.iconClass" *ngIf="button.iconClass"></i>{{button.label}}</button>
      </div>
    </div>`,
  styleUrls: ['./default-dialog.scss']
})
export class DefaultDialogComponent implements OnInit, OnChanges {
  @Input() public title:string;
  @Input() public closeButton:boolean;
  @Input() public manualClose:boolean;
  @Input() public windowClass:string;
  @Input() public dialogClass:string;
  @Input() public message:string;
  @Input() public buttons:IDialogButton[];
  @Input() public hideHeader:boolean;
  @Input() public hideFooter:boolean;
  @Input() public loading?:boolean;
  @Output() public onClose:EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private modalRef:BsModalRef,
    private modalService:BsModalService,
    private renderer:Renderer2,
    private elementRef:ElementRef
  ) {/***/
  }

  public ngOnInit():void {
    this.addWindowClasses();

    this.buttons = this.buttons || [
      {
        label: 'GA.BUTTONS.OK',
        className: 'btn-default'
      }
    ];
    _.each(this.buttons, (button:IDialogButton) => {
      if (!button.id) {
        button.id = button.label.replace(/'/g, '\\\'').replace(/"/g, '\\"'); //quotes should be escaped
      }
    });
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.title?.currentValue) {
      this.title = changes.title.currentValue;
    }
  }

  public close = (reason:string):void => {
    this.modalService.setDismissReason(reason);
    this.modalService.hide(this.modalRef?.id);
    this.onClose.emit(reason);
  };

  public btnCallBack = ($event:Event, button:IDialogButton):void => {
    $event.stopPropagation();

    if (button.onClick) {
      button.onClick((busy:boolean) => this.updateBusyButtonStatus(button.id, busy));
    } else if (!this.manualClose) {
      this.close(button.id);
    }
  };

  // used to disable all other buttons except cancel and close buttons when loading = true
  public isCancelOrCloseButton(button:IDialogButton):boolean {
    const name:string = button.id || button.label;
    return /cancel/i.test(name) || /close/i.test(name);
  }

  private findModalElement():HTMLElement {
    let modalElement:HTMLElement = this.elementRef?.nativeElement;

    do {
      modalElement = modalElement?.parentElement;
    } while (util.notNullOrUndefinedOrEmpty(modalElement) && !modalElement.classList.contains('modal') && modalElement?.tagName !== 'BODY');

    return modalElement;
  }

  private addWindowClasses():void {
    const modalElement:HTMLElement = this.findModalElement();
    const windowClasses:string[] = this.windowClass?.split(' ');
    if (modalElement) {
      _.each(windowClasses, (windowClass:string) => {
        this.renderer.addClass(modalElement, windowClass);
      });
    }
  }

  private updateBusyButtonStatus = (id:string, busy:boolean):void => {
    _.forEach(this.buttons, (button:IDialogButton) => {
      if (button.id === id) {
        button.busy = busy;
      } else {
        button.disabled = busy;
      }
    });
  };
}